<template>
    <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10.3831 19.9243C10.0081 20.0783 9.57912 19.9933 9.29312 19.7073L4.58606 15.0002H2.00003C0.897011 15.0002 0 14.1032 0 13.0002V7.00009C0 5.89707 0.897011 5.00006 2.00003 5.00006H4.58606L9.29312 0.293003C9.48412 0.102001 9.74012 0 10.0001 0C10.1291 0 10.2591 0.0250005 10.3831 0.0760012C10.7561 0.231003 11.0001 0.596007 11.0001 1.00001V19.0002C11.0001 19.4042 10.7561 19.7693 10.3831 19.9243Z"
        />
        <path
            d="M13.2929 6.29289C13.6834 5.90237 14.3166 5.90237 14.7071 6.29289L17 8.58579L19.2929 6.29289C19.6834 5.90237 20.3166 5.90237 20.7071 6.29289C21.0976 6.68342 21.0976 7.31658 20.7071 7.70711L18.4142 10L20.7071 12.2929C21.0976 12.6834 21.0976 13.3166 20.7071 13.7071C20.3166 14.0976 19.6834 14.0976 19.2929 13.7071L17 11.4142L14.7071 13.7071C14.3166 14.0976 13.6834 14.0976 13.2929 13.7071C12.9024 13.3166 12.9024 12.6834 13.2929 12.2929L15.5858 10L13.2929 7.70711C12.9024 7.31658 12.9024 6.68342 13.2929 6.29289Z"
        />
    </svg>
</template>
